export enum LDFlags {
  maintenanceModeEnabled = 'ff-maintenance-mode',
}
